import { Building2 } from 'lucide-react';
import { Combobox } from '@/components/ui/Combobox';
import { useActiveTenant } from '@/hooks/useActiveTenant';

export function TenantSwitcher() {
  const {
    isPlatformSuperadmin,
    activeTenantId,
    tenants,
    changeTenant,
  } = useActiveTenant();

  if (!isPlatformSuperadmin || tenants.length <= 1) {
    return null;
  }

  const options = tenants.map((tenant) => ({
    value: String(tenant.id),
    label: `${tenant.name} (${tenant.slug})`,
  }));

  return (
    <div className="hidden items-center gap-2 md:flex" data-testid="tenant-switcher">
      <Building2 className="h-4 w-4 text-muted-foreground" aria-hidden />
      <Combobox
        value={activeTenantId ? String(activeTenantId) : ''}
        onValueChange={(value) => {
          const tenantId = Number(value);
          if (Number.isFinite(tenantId) && tenantId > 0) {
            void changeTenant(tenantId);
          }
        }}
        options={options}
        placeholder="Tenant activo"
        searchPlaceholder="Buscar tenant..."
        emptyText="Sin tenants"
        className="w-[220px]"
      />
    </div>
  );
}
